import {OPEN_EXTERNAL_LINK, OPEN_MENU_ENTRY_LINK, OPEN_RESTAURANT_LINK} from "../constants/link.constants";

export const openExternalLink = (url) => ({
	type: OPEN_EXTERNAL_LINK,
	url,
});

export const openRestaurantLink = (restaurantId) => ({
	type: OPEN_RESTAURANT_LINK,
	restaurantId,
});

export const openMenuEntryLink = (mainCategoryId, categoryId, menuEntryId) => ({
	type: OPEN_MENU_ENTRY_LINK,
	mainCategoryId,
	categoryId,
	menuEntryId,
});
